// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"239dbbcd","52":"f1310d9f","819":"ae854f6c"}[chunkId] + ".chunk.js";
};